export interface OwnProps {
  default: boolean
  onHandleClick: (active: boolean) => void | any
  disabled?: boolean
}

export interface State {
  isActive: boolean
}

export enum TOGGLE_STATUS {
  ENABLED = 'ENABLED',
  DISABLED = 'DISABLED',
}

export type Props = OwnProps